$(window).scroll(function() {
  if ($(this).scrollTop() > 300) {
    $('.stock-top').css('opacity', 0);
  } else {
    $('.stock-top').css('opacity', 1);
  }
});

// Function to calculate the length of each SVG path
const calculatePathLength = (path) => {
  const length = path.getTotalLength();
  path.style.strokeDasharray = length;
  path.style.strokeDashoffset = length;
};

// Animate SVG paths
const svgPaths = document.querySelectorAll("svg path");
svgPaths.forEach(path => {
  calculatePathLength(path);
  gsap.to(path, { strokeDashoffset: 0, duration: 4, ease: "power1.inOut", repeat: -1, yoyo: false });
});

// Animate each letter in the h3 element
const letters = document.querySelectorAll("#loading-text span");
letters.forEach((letter, index) => {
  gsap.to(letter, { 
    opacity: 1, 
    duration: 1, 
    ease: "power1.inOut",
    delay: index * (1 / letters.length), 
    repeat: -1,
    repeatDelay: 2
  });
});

// Select the div to observe
const loadingBg = document.querySelector('.loading_bg');

// Function to check for the specific class and stop animations
const checkForClassAndStopAnimations = () => {
  if (loadingBg.classList.contains('dopple_loaded')) {
    // Kill all GSAP animations for the SVG paths and letters
    gsap.killTweensOf(svgPaths);
    gsap.killTweensOf(letters);
  }
};

// Create a MutationObserver to watch for changes in the class attribute
const observer = new MutationObserver(mutations => {
  mutations.forEach(mutation => {
    if (mutation.attributeName === 'class') {
      checkForClassAndStopAnimations();
    }
  });
});

// Start observing the loadingBg div for attribute changes
observer.observe(loadingBg, { attributes: true });

// Your existing code continues...
function show_hide_options(es){
    $(es).toggleClass('activemore');
    $('.o_2184551, .o_2184553, .o_2184554, .o_2184555, .o_2184556, .o_2184557, .o_2206346').toggleClass('optionhidden');

    // Change button text
    if ($(es).hasClass('activemore')) {
        $(es).text('LESS CUSTOMIZATION');
    } else {
        $(es).text('MORE CUSTOMIZATION');
    }
}

 $(".gallary-bg").click(function() {
    $(this).addClass("animated fadeOut");
    $(this).children().children().addClass("fadeLeft");
    $(this).children().remove();
    var rmBg = $(this);
    setTimeout(() => {
        rmBg.removeClass("gallary-bg-block");
    }, 10);
});
const closemodal = img => {
    $(img).addClass("animated fadeOut");
    $(img).children().children().addClass("fadeLeft");
    $(img).children().remove();
    var rmBg = $(img);
    setTimeout(() => {
        rmBg.removeClass("gallary-bg-block");
    }, 400);
}
const openModal = img => {
    const imgClone = $(img).closest('.mw-stack__item').find('input[type="radio"]').attr('data-image');
  // console.log(imgClone);
    $(".gallary-bg").addClass("gallary-bg-block")
   // $(".gallary-bg").html('<div class="img_center"><img src="' + imgClone + '" /></div>');
    $(".gallary-bg img").attr('onclick', '');
    $(".gallary-bg img").addClass("animated fadeIn");
    $(".gallary-bg").removeClass("animated fadeOut");
    $('.gallary-bg img').attr('id', 'myimage');

    // magnify("myimage", 2);
}
//  if($( window ).width() > 767){
$(document).ready(function() {
  //$('.price-item--regular').attr('style','opacity:0');
    var countDownDate = new Date("Dec 1, 2022 15:37:25").getTime();
    var now = new Date().getTime();

    // Find the distance between now and the count down date
    var distance = countDownDate - now;
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    setTimeout(function() {
        

        $('#custom_add_to_cart_btn').click(function(e) {

            var isvalid = true;

            $('div[data-helptext-type="required"]').each(function() {
             
                var text = $(this).text();
                var select_val = $(this).closest('.mw-option--required').find('select').val();
                if (select_val != undefined && select_val != 'undefined') {
                    if (select_val == '') {
                        $('#variant_error').remove();
                        $('.mw-apo-container').append('<p id="variant_error" style="color:red;">' + text + '</p>');
                        isvalid = false;
                        return false;
                    } else {
                        $('#variant_error').remove();
                    }
                } else {
                    if ($(this).closest('.mw-option--required').find('input[type="radio"]:checked').length < 1) {
                        $('#variant_error').remove();
                        $('.mw-apo-container').append('<p id="variant_error" style="color:red;">' + text + '</p>');
                        isvalid = false;
                        return false;
                    } else {
                        $('#variant_error').remove();
                    }
                }
            })
        })
        //$('.mw-apo-add-to-cart-cloned').hide();
      //change_image($('.product-form input[type="radio"]')); 
    }, 5000);

    setTimeout(function() {
		//console.log('time started');
        //product-form__submit button button--full-width button--primary mw-apo-add-to-cart-cloned
        $('.mw-label').hover(function() {
            var img = $(this).find('input[type="radio"]').attr('data-image');
//console.log('time hovered');
            setTimeout(function() {
               
                if (img != null && img != undefined && img != 'undefined') {
                  // $('.tippy-box').attr('onclick', 'openModal(this)');
				  // console.log('time openModal');
				   $(".gallary-bg").html('<div class="img_center"><img src="' + img + '" /></div>');
                }
            }, 200);
        })
        setTimeout(function() {
            $('.chair_summary').each(function() {
               // $(this).find('h4').addClass('tab');
               // $(this).find('ul').addClass('tabcontent');
               // $(this).find('ul').hide();
            })
            $('.tab').click(function() {

                if ($(this).hasClass('active')) {
                   if ($(this).attr('data-id') == 'o_520080') {
                        $('#o_520087').hide();
                    }
                    if ($(this).attr('data-id') == 'o_2081593') {
                        $('#o_2081594').hide();
                        $('#o_520257').hide();
                    }
                    if ($(this).attr('data-id') == 'o_502386') {
                        $('#o_525895').hide();
                    } 
                   $('.tabcontent').hide(400);
                    $('.tab').removeClass('active');

                } else {
                    // Anthros Metrics 
                    if ($(this).attr('data-id') == 'o_520080') {
                        $('#o_520087').show();
                    } else if ($(this).attr('data-id') != undefined) {
                        $('#o_520087').hide();
                    }
                    // Casters 
                    if ($(this).attr('data-id') == 'o_2081593') {
                        $('#o_2081594').show();
                        $('#o_520257').show();
                        $('#o_638388').show();
                    } else if ($(this).attr('data-id') != undefined) {
                        $('#o_2081594').hide();
                       // $('#o_520257').hide();
                       // $('#o_638388').hide();
                    }
                    // Trim Options
                    if ($(this).attr('data-id') == 'o_502386') {
                        $('#o_525895').show();

                    } else if ($(this).attr('data-id') != undefined) {
                        $('#o_525895').hide();
                    }

                    if ($(this).attr('data-id') == 'o_638387') {
                        //$('#o_638388').toggle();

                    } else if ($(this).attr('data-id') != undefined) {
                       // $('#o_638388').hide();
                    }

                    $('.tabcontent').hide();
                    $(this).closest('.chair_summary').find('.tabcontent').first().show(400);
                    $('.tab').removeClass('active');
                    $(this).toggleClass('active');
               }
			   if($( window ).width() < 993){
		   $("html, body").animate({
            scrollTop: $(this).offset().top - 435
        }, 300); 
		   }
            })
        }, 2000);
        // cHANGE IMAGE FUNCTION
        function numberWithCommas(number) {
            var parts = number.toString().split(".");
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            return parts.join(".");
        }

        function change_image(et) {
            var rules = localStorage.getItem('rules');
            var variant_name = $(et).attr('name');
            var isvalid = true;

            $('div[data-helptext-type="required"]').each(function() {
              
                var text = $(this).text();
                var select_val = $(this).closest('.mw-option--required').find('select').val();
                if (select_val != undefined && select_val != 'undefined') {
                    if (select_val == '') {

                        isvalid = false;
                        // return false;
                    } else {
                        $('#variant_error').remove();
                    }
                } else {
                    if ($(this).closest('.mw-option--required').find('input[type="radio"]:checked').length < 1) {

                        isvalid = false;
                        // return false;
                    } else {
                        $('#variant_error').remove();
                    }
                }

            })
        
            if (isvalid == true) {

                $('#custom_add_to_cart_btn').hide();
                $('.mw-apo-add-to-cart-cloned').show();
            } else {
              //  $('#custom_add_to_cart_btn').show();
              //  $('.mw-apo-add-to-cart-cloned').hide();
			   $('#custom_add_to_cart_btn').hide();
                $('.mw-apo-add-to-cart-cloned').show();
            }
            var image_name = '';

            var pr_price = $('#product_price').val();
            pr_price = parseFloat(pr_price);

            var variant_price = 0;
            $('.product-form input[type="radio"]:checked').each(function() {

                variant_price = variant_price + parseFloat($(this).attr('data-price'));
            })
            $('.product-form select option:selected').each(function() {
                var prc = $(this).attr('data-price');
                if (prc != undefined && prc != 'undefined' && prc != null && prc != '') {
                    variant_price = variant_price + parseFloat($(this).attr('data-price'));
                }
            })
            var total_price = pr_price + variant_price;
            //$('#product_price').val(total_price)
			if(!isNaN(total_price)){
			var extra_price = total_price + 397
            $('.extra_price').text('$'+numberWithCommas(extra_price.toFixed(2)));
            $('.price-item--regular').text('$' + numberWithCommas(total_price.toFixed(2)) + '');
			//$('.price-item--regular').attr('style','opacity:1');
			}
            $('.klarna_price').text('$' + (total_price / 4).toFixed(2));
            variant_price = parseFloat(variant_price);

            $.each(JSON.parse(rules), function(index, value) {
                var is_true = true;
                var str1 = value.rule.title;
                if (value.rule.title != '' && str1.indexOf('{index}') != -1) {
                    $.each(value.rule.conditions, function(ind, val) {
                        var option_val = $('input[name="mw_opts[' + val.option_id + ']"]:checked').val();
                       
                        if (option_val == 'v_502382_l6dixwf8') {
                            $('.4-stroke-soft').show();
                        } else if (option_val == 'v_2883688') {
                            $('.4-stroke-soft').hide();
                        }
                        //if(val.values[0] != option_val){
                        if ($.inArray(option_val, val.values) == -1) {
                            is_true = false;
                        }
                    })
                } else {
                    is_true = false;
                }
                if (is_true == true) {
                 
                 

                    return value.rule.title;

                   // return false;
                }
             
            })
        }
        setTimeout(function() {
			
    $('.product-form input[type="radio"], .product-form select').each(function() {
             
                var name = change_image($(this));
 
            })
			$('.product-form input[type="radio"]:checked').each(function(){
				 let title_name = $(this).closest('div').find('.title_name').text();
				 if($(this).val() == 'v_19129218'){
					 title_name += '<del>$199</del>'
				 }
				 let title_format = title_name.split('+');
				 let bold_title ='';
				  if(title_format[1] != undefined){
					  bold_title = '+'+title_format[1];
				  }
				 $(this).closest('.chair_summary').find('.new_title_name').remove();
				 $(this).closest('.chair_summary').find('h4').append('<span class="new_title_name">'+title_format[0]+'<b>'+ bold_title+'</b>'+'</span>');
				 $(this).closest('.mw-option__value').addClass('radio_active');
				
			})
              $('.product-form input[type="radio"]').change(function() {
				 let title_name = $(this).closest('div').find('.title_name').text();
				 if($(this).val() == 'v_19129218'){
					 title_name += '<del>$199</del>'
				 }
				 let title_format = title_name.split('+');
				 let bold_title ='';
				  if(title_format[1] != undefined){
					  bold_title = '+'+title_format[1];
				  }
				 $(this).closest('.chair_summary').find('.new_title_name').remove();
				 $(this).closest('.chair_summary').find('h4').append('<span class="new_title_name">'+title_format[0]+'<b>'+ bold_title+'</b>'+'</span>');
				 $(this).closest('.mw-option__container').find('.mw-option__value').removeClass('radio_active');
				$(this).closest('.mw-option__value').addClass('radio_active');
				  
			  })
            $('.product-form input[type="radio"], .product-form select').change(function() {
				var valchecked = $(this).val();
				//console.log('.fixed_select_option='+valchecked);
				console.log('is_checked='+$(this).is(":checked"));
				console.log('valchecked='+valchecked);
				$(this).closest('.mw-option__container').find('.mw-option__value').removeClass('radio_active');
				$(this).closest('.mw-option__value').addClass('radio_active');
				if(valchecked == 'v_18929376'){
					
					$('body').addClass('darkmode');
				}
				if(valchecked == 'v_18929375'){
					
					$('body').removeClass('darkmode');
				}
              
			var img_click = $(this).attr('data-image');
			//$(this).closest('.mw-option').find('.fixed_select_option').hide();
			if(img_click != '' && img_click != undefined && img_click != 'undefined' && img_click != null){
				//$(this).closest('.mw-stack__item').find('.fixed_select_option').show();
				//alert('sds');
			}
                if (valchecked == 'v_17990463') {
                    $('#v_17990486').click();
                }
                if (valchecked == 'v_17990464') {
                    $('#v_17990487').click();
                }
				if( valchecked == "v_3035424" || valchecked == "v_3035425" || valchecked == "v_520087_lhbj3vep"){
					$('.showhide_weight').show();
				}else{
					$('.showhide_weight').hide();
				}
                var name = change_image($(this));

            })
        }, 1000);

    }, 3000);
    $(window).scroll(function() {
        var sticky = $('.header-wrapper'),
            scroll = $(window).scrollTop();

        if (scroll >= 50) sticky.addClass('added_class');
        else sticky.removeClass('added_class');
    });

    var cache_hash = window.mwApoInit.cache_hash;
    var product_id = window.mwApoInit.product.id;
    var variants_id = window.mwApoInit.product.variants[0].id;
    // Desktop Start
  
    // Desktop End 
    // Mobile Start
    //if ($(window).width() < 993) {
	let checkExist = setInterval(function() {
    if ($('.mw-apo-container').length) {
        // Fire your event
      //  setTimeout(function() {
            $.getJSON('https://apo-api.mageworx.com/front/product/anthros-dealer-2.myshopify.com/' + cache_hash + '/' + product_id + '/' + variants_id + '.js', function(jd) {

                localStorage.setItem('rules', JSON.stringify(jd.rules));
                var options = jd.options;
                var values = jd.values;

                var html = '';

                var i = 0;
                setTimeout(function() {
                    $.each(values, function(key, val) {
                        if (val.value.input_type == 'select') {
                            $('select option[value="' + val.value.id + '"]').attr('data-price', val.value.pricing.price);

                        }
                        $('#' + val.value.id).attr('data-price', val.value.pricing.price);
                        $('#' + val.value.id).closest('.mw-stack__item').append('<span class="title_name">' + val.value.title + '</span>');
                        if (val.value.id == "v_3993314" || val.value.id == "v_3993315") {
                            $('#' + val.value.id).closest('.mw-stack__item').append(val.value.description);
                        }
						
						if(val.value.images[0] != null && val.value.images[0] != undefined){
					  var hover_image = val.value.images[0]['url'];
					$('#'+val.value.id).attr('data-image',val.value.images[0]['url']); 
				var disc_class = '';
				var option_description = '';
				if(val.value.description != ''){
					disc_class = 'with_description';
					option_description = '<div class="option_description">'+val.value.description+'</div>';
					
				}
					if(val.value.images[0].hover == true ){
					if(val.value.is_default == true){			
				//	console.log(val.value.is_default);
			
					
					}else{
					
						
					}
				  }else if(val.value.description != ''){
					  var style = 'none';
					  if(val.value.is_default == true){
						  style = 'block';
						  }
					
					  
					  
				  }
					
				  }else{
					  
					  
				  }
						
                        //$('#'+val.value.id).closest('.mw-stack__item').append(val.value.description);
                    })
                    var event = new Event("optionsReady");

                    window.dispatchEvent(event);
                }, 1000);

                $.each(options, function(index, value) {

                    setTimeout(function() {
                        $('#' + value.id).wrap('<div class="chair_summary '+value.id+'"></div>');
                        //o_2080842 o_520257 o_2080843
                        if (value.id != 'o_2081594' && value.id != 'o_2080843' && value.id != 'o_520257' && value.id != 'o_525895' && value.id != 'o_638388') {
                           // $('#' + value.id).addClass('tabcontent');
							
							 if(value.id == "o_2081589"){
					$('<h4 class="tab1 active" data-id="'+value.id+'" >'+value.title+'</h4>').insertBefore($('#'+value.id)); 
					 $('#'+value.id).show();
				 }else{
					$('<h4 class="tab1" data-id="'+value.id+'" >'+value.title+'</h4>').insertBefore($('#'+value.id)); 
					 
				 }
                         //   $('<h4 class="tab" data-id="' + value.id + '" >' + value.title + '</h4>').insertBefore($('#' + value.id));
                        }
                        $('#' + value.id).find('.mw-text--style-strong').html(value.name);
                        $('#' + value.id).append(value.description);

                    }, 100);

                    i = i + 1;
						if(value.id == "o_2241685"){
						setTimeout(function() {
					$('[data-value-id="v_19380061"], [data-value-id="v_19380062"], [data-value-id="v_19380063"], [data-value-id="v_19380064"], [data-value-id="v_19380065"], [data-value-id="v_18919688"], [data-value-id="v_21120853"]').wrapAll('<div class="shapeknit"/>'); 
					
					$('div.mw-option__value[data-value-id="v_19380066"], div.mw-option__value[data-value-id="v_19380067"], div.mw-option__value[data-value-id="v_19380068"], div.mw-option__value[data-value-id="v_19380069"]').wrapAll('<div class="port_leather"/>'); 
				  }, 1000);
				 }	
			if(value.id == "o_2241686"){
				//setTimeout(function() {
					$('[data-value-id="v_19380070"]').wrapAll('<div class="standard_black"/>'); 
					$('[data-value-id="v_19380071"], [data-value-id="v_19380072"], [data-value-id="v_19380073"], [data-value-id="v_19380074"], [data-value-id="v_19380075"], [data-value-id="v_18955446"]').wrapAll('<div class="wood_section"/>'); 
					$('[data-value-id="v_19380076"], [data-value-id="v_19380077"],[data-value-id="v_19380078"], [data-value-id="v_18919699"], [data-value-id="v_18919700"], [data-value-id="v_18919701"], [data-value-id="v_18919702"], [data-value-id="v_18919703"], [data-value-id="v_18220864"], [data-value-id="v_18220865"], [data-value-id="v_19354919"], [data-value-id="v_19354920"], [data-value-id="v_20616429"], [data-value-id="v_20629096"], [data-value-id="v_20629097"], [data-value-id="v_20629098"], [data-value-id="v_20629099"]').wrapAll('<div class="specialty"/>'); 
					
				   //}, 1000);
				 }	
					
                });

                $('.list_items .item').click(function() {
                    var show_id = $(this).attr('data-id');
                    $('.mw-option--type-swatch').hide();
                    $('#' + show_id).show();
                    $('.list_items .item').removeClass('active');
                    $(this).addClass('active');
                })

            });
			//setTimeout(function() {
					$('<div class="shapeknit_text"><h2>Athlon Performance Fabric</h2><p>A high performance upholstery designed to meet the demands of daily use while providing exceptional comfort and style.</p></div>').insertBefore($('div[data-value-id="v_19380061"]'));
					 $('<div class="port_leather_text"><h2>Port Leather Alternative</h2><p>An environmentally conscious synthetic leather that is phthalate free. Wipeable for cleaning and disinfecting</p></div>').insertBefore($('div[data-value-id="v_19380066"]'));
					 
					 
					 $('<div class="standard_black_text"><h2>Standard Black</h2></div>').insertBefore($('div[data-value-id="v_19380070"]'));
					 $('<div class="wood_text"><h2 style="display: inline; margin-right: 3px;">Wood</h2><sup id="backs_infocon" style="display: inline;">&#9432;</sup><span id="backs_info" style="display: none;">Anthros real-wood back panels are produced using a high-grade White Oak, with beautiful grain spacing and coloring.</span></div>').insertBefore($('div[data-value-id="v_19380071"]'));
					 $('<div class="specialty_text"><h2>Specialty</h2></div>').insertBefore($('div[data-value-id="v_19380076"]'));
					  $('#backs_infocon').click(function() {
		//console.log('dsfsdf');
        $('#backs_info').toggle(); // This toggles the display
    });
    // Optional: Toggle on hover
    $('#backs_infocon').hover(
        function() {
            $('#backs_info').show(); // Show on mouse enter
        }, 
        function() {
            $('#backs_info').hide(); // Hide on mouse leave
        }
    );
	if (!window.location.search.includes('bitcoin')) {
	//$('<div class="see_more_btn"><a href="javascript:void(0);" onclick="show_hide_options(this)">MORE CUSTOMIZATION </a></div><div class="text_under_btn"><p>Customize the Seat Fabric, Back Panel, Wheel Thread, and MORE.</p></div>').insertAfter($('.mw-apo-container'));
	}
			//	}, 1000);	 
    // Toggle on click
   
	 $('.extra_infocon').hover(
        function() {
            $('.extra_info').show(); // Show on mouse enter
        }, 
        function() {
            $('.extra_info').hide(); // Hide on mouse leave
        }
    );
	
       // }, 1000);
	
        console.log('.mw-apo-container has loaded!');
		if (window.location.search.includes('gaming')) {
			 if ($('#v_18929376').length > 0){
			$('#v_18929376')[0].click();
			$('body').addClass('darkmode');
			 }
		}
        if (window.location.search.includes('EFG-team')) {
          if (
            $('#v_18929376').length > 0
          ) {
            $('#v_18929376')[0].click();
            $('body').addClass('darkmode');
          }
        }
		if (window.location.search.includes('bitcoin')) {
			setTimeout(function() {
			//$('.back_items').hide();  
			$('#v_18929376').click();
			$('body').addClass('darkmode');
			//$('#v_19580996').click();
		 $('[data-value-id="v_19580996"], [data-value-id="v_19580997"]').show(); 
		 $('.o_2185385, .o_2185372, .standard_black_text, .standard_black, .wood_text, .wood_section, .specialty_text, .specialty').hide();
			$('.o_2184551, .o_2184553, .o_2184554, .o_2184555, .o_2184556, .o_2184557, .o_2206346').show();
		 }, 500);
	   }
	    $('.product-form input[type="radio"]').change(function() {
				 let title_name = $(this).closest('div').find('.title_name').text();
				 if($(this).val() == 'v_19129218'){
					 title_name += '<del>$199</del>'
				 }
				  let title_format = title_name.split('+');
				  let bold_title ='';
				  if(title_format[1] != undefined){
					  bold_title = '+'+title_format[1];
				  }
				 $(this).closest('.chair_summary').find('.new_title_name').remove();
				 $(this).closest('.chair_summary').find('h4').append('<span class="new_title_name">'+title_format[0]+'<b>'+ bold_title+'</b>'+'</span>');
				  
			  })
        clearInterval(checkExist);
    }
}, 100); // check every 100ms
   // }
    // Mobile End
    $(document).ready(function() {
        setTimeout(function() {
            function showhide(et) {
                var show_id = $(et).attr('data-id');
                $('mw-option--type-swatch').hide();
                $('#' + show_id).show();
            }
        }, 2000);
	
		
    });

    $('.custom-product').show();

    $('#days_left').text(days);
});
// }

//DOPPLE CONTROLS FOR AR AND SNAPSHOT
let avAr // The <av-ar> tag
let arDiv // QR code container <div>
let arTriggerButton // Custom AR trigger button
let arCloseButton // Custom AR close
const doppleVisual = document.querySelector('atlatl-visual')
const doppleProduct = document.querySelector('av-product')

document.addEventListener("DOMContentLoaded", () => {
    avAr = document.getElementById('ar-visualizer')
    arDiv = document.querySelector('.custom-ar-div')
    arTriggerButton = document.getElementById('custom-ar-trigger-button')
    arCloseButton = document.getElementById('close-ar-trigger-button')
    if ($(arDiv).css('display') == 'none') {
        arTriggerButton.addEventListener('click', () => {
            arDiv.style.display = 'block'
        })
    }

    arCloseButton.addEventListener('click', () => {
        if ($(arDiv).css('display') == 'block') {
            arDiv.style.display = 'none'
        }
    })
    // The <av-ar> element will then fire an 'ar-code-generated' event once complete
    avAr.addEventListener('ar-code-generated', () => {
        const qrImage = document.getElementById('qr-image')
        qrImage.src = 'data:image/png;base64,' + avAr.qrCode
    })

    // The `<av-ar>` element will fire an 'ar-code-status' event as it updates
    avAr.addEventListener('ar-code-status', (event) => {
        const {
            currentStep,
            totalSteps,
            overallProgress
        } = event.detail
        const label = document.getElementById('ar-progress-percent')
        const bar = document.getElementById('progress-bar')

        label.innerHTML = `AR loading: ${overallProgress * 100}%`
        bar.value = currentStep
        bar.max = totalSteps
    })
    // Get the "Add to Cart" button
    setTimeout(function() {
   
    }, 6000)
})

window.addEventListener('load', async () => {

  await doppleVisual.ready()

    // Initial setup: hide the header initially if the screen width is more than 992px.
    if (window.innerWidth > 992) {
       $('.header').slideUp(0);
    }

    let isHeaderHovered = false;  // Flag to track header hover state

    if (window.innerWidth > 992) {
        // Handle mouse hover on header
        $('.header').hover(
            function() {
                isHeaderHovered = true;
            },
            function() {
                isHeaderHovered = false;
                // Slide up the header only if the mouse is not near the top
                $(document).on('mousemove', function(e) {
                    if (e.clientY > 30 && !isHeaderHovered) {
                       $('.header').slideUp();
                    }
                });
            }
        );

        // Event listener for mouse movement near the top of the page.
        $(document).on('mousemove', function(e) {
            if (e.clientY <= 10 || isHeaderHovered) {
                // If mouse is within the top 10px of the viewport or on the header, slide down the header.
               $('.header').slideDown();
            }
        });
    }
    document.querySelector('.sticky_img').classList.add('dopple_loaded');
    document.querySelector('.mw-apo-price-custom').classList.add('dopple_loaded');
    setTimeout(() => {
     //$('#v_18919714')[0].click();
		
      // Check if the URL contains the query parameter 'drlupo'
	   if (window.location.search.includes('bitcoin')) {
			
			
			$('#v_19580996').click();
	   }
      // Check if the URL contains the query parameter 'drlupo'
      if (window.location.search.includes('drlupo')) {
          // Check if the element exists before interacting with it
          if ($('#v_18919699').length > 0 && $('.mw-option__value[data-value-id="v_18919699"]').length > 0) {
			  $('#v_18929376')[0].click();
              $('#v_18919699')[0].click();
              $('.mw-option__value[data-value-id="v_17479846"]').css('display', 'block');
            
              // Add the discount code without removing 'drlupo'
              var discountCode = "8JN8WESM";
              var urlParams = new URLSearchParams(window.location.search); // Preserve current search parameters
              
              // Check if the discount already exists, if not add it
              if (!urlParams.has('discount')) {
                  urlParams.append('discount', discountCode);
                  var newUrl = `${window.location.pathname}?${urlParams.toString()}`;
                  window.history.replaceState(null, null, newUrl); // Update the URL without reloading the page
              }
          } else {
              console.log('Element not found: #v_17479846 or .mw-option__value[data-value-id="v_17479846"]');
          }
          
      } else {
       // $('#v_18919694')[0].click();
       // $('#v_18142710')[0].click();
        $('[data-value-id="v_18142709"]').hide();
      }
	  console.log('loading_price');
      $('.loading_price').attr('style', 'opacity:0');
      $('.price-item--regular').attr('style', 'opacity:1');
      $('.extra_price').attr('style', 'opacity:1');
  
      if (window.innerWidth >= 900) {
          doppleProduct.product.setValue('runRotation', true);
      }
      $(".sticky_img").click(function(){
          doppleProduct.product.setValue('runRotation', false);
      });
      // try clicking `sel` every `interval` ms until its wrapper has `selectedClass`
      // or until we've hit `maxTries`
      function clickUntilSelected(
        sel,
        {
          container = '.mw-option__value',
          selectedClass = 'mw-option__value--selected',
          interval = 100,
          maxTries = 20
        } = {}
      ) {
        let tries = 0;
        const timer = setInterval(() => {
          const $input   = $(sel);
          const $wrapper = $input.closest(container);
     // console.log('checked value', $wrapper.find('input:checked').length);
          // if wrapper isn't found or already selected, stop
          if (!$wrapper.length || $wrapper.find('input:checked').length > 0) {
            clearInterval(timer);
            return;
          }
      
          // if we've tried enough times, give up
          if (++tries >= maxTries) {
            clearInterval(timer);
            console.warn(`clickUntilSelected: failed to select ${sel} after ${maxTries} tries`);
            return;
          }
      console.log('input', $input)
          // otherwise, fire the click and try again later
          $input[0].click();
        }, interval);
      }
      
      // batch version
      function clickIfNotSelected(selectors) {
        selectors.forEach(sel => clickUntilSelected(sel));
      }
      
	  //change control caps
	    $('#v_19380059').click(function() {
        setTimeout(function() {
          clickIfNotSelected([
            '#v_19380080'
           
          ]);
        }, 100);
      });
	     $('#v_19380060').click(function() {
        setTimeout(function() {
          clickIfNotSelected([
            '#v_19380079'
           
          ]);
        }, 100);
      });
      // your handlers
      $('#v_18929218').click(function() {
        setTimeout(function() {
          clickIfNotSelected([
            '#v_18919681',
            '#v_18919684',
            '#v_18919695'
          ]);
        }, 100);
      });
      $('#v_18929219').click(function() {
        setTimeout(function() {
          clickIfNotSelected([
            '#v_18919682',
            '#v_18919683',
            '#v_18919694'
          ]);
        }, 100);
      });
      $('#v_18929373').click(function() {
        setTimeout(function() {
          clickIfNotSelected([
            '#v_18919681',
            '#v_18919684',
            '#v_18919697'
          ]);
        }, 100);
      });
      $('#v_18929374').click(function() {
        setTimeout(function() {
          clickIfNotSelected([
            '#v_18919682',
            '#v_18919685',
            '#v_18919695'
          ]);
        }, 100);
      });
      $('#v_19593544').click(function() {
        setTimeout(function() {
          clickIfNotSelected([
            '#v_18919682',
            '#v_18919683',
            '#v_18919698'
          ]);
        }, 100);
      });
      $('#v_19593545').click(function() {
        setTimeout(function() {
          clickIfNotSelected([
            '#v_18919681',
            '#v_18919690',
            '#v_18919696'
          ]);
        }, 100);
      });
      $('#v_19593546').click(function() {
        setTimeout(function() {
          clickIfNotSelected([
            '#v_18919682',
            '#v_18919688',
            '#v_18919698'
          ]);
        }, 100);
      });
      $('#v_17990463').click(function() {
        setTimeout(function() {
          $('#v_18142710')[0].click();
          $('[data-value-id="v_18142709"]').hide();
          $('[data-value-id="v_18142710"]').show(); 
        }, 100);
      });
      $('#v_17990464').click(function() {
        setTimeout(function() {
          $('#v_18142709')[0].click();
          $('[data-value-id="v_18142710"]').hide();
          $('[data-value-id="v_18142709"]').show(); 
        }, 100);
      })
      $('#v_18919681').click(function() {
          $('#v_18919705')[0].click();
          setTimeout(function() {
            doppleProduct.product.setValue('cameraView', 'back');
          }, 100);
      });
      $('#v_18919682').click(function() {
          $('#v_18919704')[0].click();
          setTimeout(function() {
            doppleProduct.product.setValue('cameraView', 'back');
          }, 100);
      });
      $(".o_2241684 input").click(function(){
          doppleProduct.product.setValue('runRotation', false);
          doppleProduct.product.setValue('cameraView', 'back');
      });
  
      $(".o_2241685 input").click(function(){
          doppleProduct.product.setValue('runRotation', false);
          doppleProduct.product.setValue('cameraView', 'front');
      });
  
      $(".o_2241686 input").click(function(){
          doppleProduct.product.setValue('runRotation', false);
          doppleProduct.product.setValue('cameraView', 'back');
      });
  
      $(".o_2241691 input").click(function(){
          doppleProduct.product.setValue('runRotation', false);
          doppleProduct.product.setValue('cameraView', 'front');
      });
	$(".o_2241687 input").click(function(){
          doppleProduct.product.setValue('runRotation', false);
          doppleProduct.product.setValue('cameraView', 'lowbackAdjust');
      });
      doppleProduct.product.setValue('base', 'fiveSpoke');
  }, 200);
})

$('#nativeUIIconButton-av-ar').click(function() {
    $('.sticky_img').css({
        'z-index': '10000',
    });
});

$('.native-ui__modal-close-button').click(function() {
    $('.sticky_img').css({
        'z-index': '9',
    });
});
$(document).ready(function(){

  if($( window ).width() > 992){
  var height = $(window).height();
  
  
  //console.log('avCanvas='+$('#main-container').innerHeight());
  $('.custom_product_section.product__info-wrapper').attr('style','max-height:'+height+'px; overflow:scroll;');
  window.addEventListener('resize', function(event){
	  height = $(window).height();
  //console.log('resize='+height);
  $('.custom_product_section.product__info-wrapper').attr('style','max-height:'+height+'px;  overflow:scroll;');
 
  
});
  }
  
  
  checkScroll();

    $(window).scroll(function() {
        checkScroll();
    });

    function checkScroll() {
		if($( window ).width() < 992){
        if ($(window).scrollTop() > 0) {
			$('.mobile_price').addClass('price_fixed');
            $('.review_img').fadeOut(); // Hides the element when not at the top
            $('.affirm-line').fadeOut(); // Hides the element when not at the top
           $('.mobile_display').fadeOut(); // Hides the element when not at the top
        } else {
			$('.mobile_price').removeClass('price_fixed');
            $('.affirm-line').fadeIn(); // Shows the element when at the top
            $('.review_img').fadeIn(); // Shows the element when at the top
           $('.mobile_display').fadeIn(); // Shows the element when at the top
        }
    }
    }
 
  setInterval(function () {
		$('.option_error').remove();
		var error_html = '';
		$('.mw-stack__item .mw-option__helptext').each(function(){
			if(!$(this).hasClass('mw-hidden')){
				error_html += '<p>'+$(this).text()+'</p>';
		
			}
			
		})
	  $('<div id="option_error" class="option_error">'+error_html+'</div>').insertBefore('.affirm-line');
	  }, 100);
  
});